import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=2a859f36&"
import script from "./invoice-detail.vue?vue&type=script&lang=js&"
export * from "./invoice-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports